<template>
    <div >

        <div id="modal-full" style="z-index: 100000;" uk-modal>
            <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical" style="padding-top: 30px;z-index: 2100;min-width: 70%;">
                <div v-if="current_program != null">
                    <button @click="current_program = null" class="uk-modal-close-full" style="background:transparent;position: absolute;float: right;margin-right: -20px;margin-top: -18px;border: 0;padding: 0;height: 50px;width: 50px;border-radius: 50px;">
                        <img src="/images/schedule/toggle-close-x.svg" style="height: 50px;width: 50px;background:white;border-radius: 50px;"/>
                    </button>
                    <div class="uk-grid-collapse uk-child-width-1-2@s uk-flex-top uk-grid" style="" uk-grid="">
                        <div style="width: 100%;">
                            <span>{{current_program.program_details.text_formatted_date}} at {{current_program.program_details.show_time}} on {{channel}}</span>
                            <br />
                            <span class="pbs-schedule-grid-title">{{current_program.program_details.series_title}}</span>
                            <br />
                            <span class="pbs-schedule-grid-sub-title" v-if="current_program.program_details.episode_title.length > 0 && current_program.program_details.series_title !== current_program.program_details.episode_title">{{current_program.program_details.episode_title}}</span>
                            <br />
                            <br />
                            <ProgramDetails  v-bind:air_data="current_program" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

<!--      ************************************************-->

      <!--NEW MENU - TOP BUTTONS-->


      <div class="uk-width-1-1 schedule-header" style="background: #f8eeca; padding: 0;margin-top:0px;" v-if="exact_match !== '1' && !loading">
      <TopNavigationBar />

        <div style="background-color: #F8EECA; padding: 10px;">
          <div class="gridcenter1200" style="padding: 25px 10px 10px;min-height: 147px;">

            <div class="all-air-dates-progtitle" style="float: left;font-size: 48px;">PROGRAMS A-Z</div>
            <div class="" style="float: right; color: black; font-size: 22px; font-family: Avenir-Heavy;text-transform: uppercase">{{date_range.min_date_formatted}} - {{date_range.max_date_formatted}}</div>
            <div style="clear: both; margin-bottom: 10px;"></div>

            <div class="uk-grid uk-grid-small">
              <div class="uk-width-1-2@s">
                <select placeholder="filter by channel" class="select-pbs-schedule-dropdown" style="width: 100%;" v-model="channel" @change="change_channel">
                  <option class="select-pbs-schedule-dropdown-option" value="-1">filter by channel</option>
                  <!-- <option value="-1">ALL CHANNELS</option> -->
                  <option class="select-pbs-schedule-dropdown-option" value="1">Channel 12.1 &mdash; PBS12</option>
                  <option class="select-pbs-schedule-dropdown-option" value="2">Channel 12.2 &mdash; FNX</option>
                  <option class="select-pbs-schedule-dropdown-option" value="3">Channel 12.3 &mdash; DW</option>
                  <option class="select-pbs-schedule-dropdown-option" value="4">Channel 12.4 &mdash; NHK WORLD-JAPAN</option>
                </select>
              </div>
              <div class="uk-width-1-2@s">
                <select placeholder="filter by genre" class="select-pbs-schedule-dropdown" v-model="text_search_input" style="width: 100%;">
                  <option class="select-pbs-schedule-dropdown-option" :value="null">filter by genre</option>
                  <option class="select-pbs-schedule-dropdown-option" value="">All</option>
                  <option class="select-pbs-schedule-dropdown-option" v-for="genre in list_genres" v-bind:key="genre" :value="genre">{{translate_genre(genre)}}</option>
                </select>
              </div>
            </div>

          </div>
        </div>

        <!-- NEW MENU-- >
        <div>
          < !-- MENU JUST CHANNELS + PROGRAMS A-Z Title -- >
          <div style="background-color: rgb(248, 238, 202); padding: 25px 0 20px 0;">
            <div class="uk-grid uk-grid-large gridcenter1200">
              <div class="uk-width-3-5@m" style="padding: 0px 5px;">
                <div style="float: left; padding: 0 10px 0 0;">
                  <div style="font-size: 44px; font-family: Avenir-medium; line-height: 1.4;">PROGRAMS A - Z</div>
                </div>
                <div style="clear: both;"></div>
              </div>
            </div>
          </div>
          < !--CHANNELS-- >
          <div style="background-color: #F6DF98; padding-top: 10px; padding-bottom: 10px;">
            <div class="uk-grid uk-grid-large gridcenter1200">
              <div class="uk-width-1-1@m uk-visible@xs uk-hidden@s" style="padding: 0px 5px 10px 5px;">
                <select id="channel_selector_dropdown" class="select-pbs-schedule" name="ch" v-model="channel" @change="change_channel">
                  <option value="-1">ALL CHANNELS</option>
                  <option value="1">CHANNEL 12.1 &mdash; PBS 12</option>
                  <option value="2">CHANNEL 12.2 &mdash; FNX</option>
                  <option value="3">CHANNEL 12.3 &mdash; Deutsche Welle</option>
                  <option value="4">CHANNEL 12.4 &mdash; NHK World</option>
                </select>
              </div>
              <div class="uk-width-1-1@m uk-visible@s" style="padding: 0px;">
                <div style="border-bottom: 1px solid #00AEB4;"></div>
                <ul class="uk-child-width-expand uk-tab-bottom" uk-tab style="margin-top: 0;">
                  <li @click="change_channel('-1')" style="border: 0;" class="uk-hidden@xs uk-visible@s uk-active"><a href="#"><div style="max-height: 25px;">ALL CHANNELS</div></a></li>
                  <li @click="change_channel('1')" style="border: 0;" ><a href="#"><img src="/images/schedule/channel-121-pbs12.svg" style="max-height: 25px;"></a></li>
                  <li @click="change_channel('2')" style="border: 0;"><a href="#"><img src="/images/schedule/channel-122-fnx.svg" style="max-height: 25px;"></a></li>
                  <li @click="change_channel('3')" style="border: 0;"><a href="#"><img src="/images/schedule/channel-123-dw.svg" style="max-height: 25px;"></a></li>
                  <li @click="change_channel('4')" style="border: 0;"><a href="#"><img src="/images/schedule/channel-124-nhk.svg" style="max-height: 25px;"></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        -->
      </div>



<!--      ************************************************-->

        <div id="az-anchor-div"></div>

        <div style="background-color: #4C6464;position: sticky;top: 226px;">
          <div class="uk-grid uk-grid-large gridcenter1200" style="padding: 5px 5px;" >
            <div class="uk-width-1-1@m" style="padding: 0px 0 0 0;">

              <div class="uk-visible@xs uk-hidden@m" style="height: 15px;"></div>

              <!--
              <div style="border-bottom: 1px solid #00AEB4;"></div>
              -->
              <div class="uk-tab-bottom uk-visible@xs uk-hidden@s" v-for="(letter, n) in az" v-bind:key="n" :style="`border: 0;${(letter === '0-9')?'min-width: 62px;':''};text-align: center;`" style="display: inline;">
                <div class="uk-active" style="float: left;display: inline;min-width:17px;min-height: 20px; color: white;cursor:pointer;color: rgb(1 174 180);border-color: rgb(1 174 180);font-family: Avenir-heavy;">
                  <a :href="`#az_program_${letter}`" uk-scroll="offset: 280" style="color: white;font-size: .875rem;">{{letter}}</a>
                </div>
              </div>
              <div class="uk-visible@xs uk-hidden@m" style="height: 20px;"></div>

              <ul class="uk-child-width-expand uk-tab-bottom uk-visible@s" uk-tab style="margin-top: 0px; ">
                <li v-for="(letter, n) in az" v-bind:key="n" :style="`border: 0;${(letter === '0-9')?'min-width: 62px;':''}`">
                  <a :href="`#az_program_${letter}`" uk-scroll="offset: 280" style="display: inline-block;"><div style="min-width:20px;min-height: 20px; color: white;cursor:pointer">{{letter}}</div></a>
                </li>
              </ul>

            </div>
          </div>
        </div>
        <div v-if="filtered_programs_list_size === 0" class="a-z-programs-ul uk-list uk-list-divider uk-width-1-1" style="margin-top: 20px;">
          <div style="max-width: 1100px;margin-left: auto;margin-right: auto;text-align: left;">
            No results
          </div>
        </div>
        <ul v-else v-for="(letter, n) in az" v-bind:key="n" class="a-z-programs-ul uk-list uk-list-divider uk-width-1-1" :style="'margin-top:0px;' + ((letter === 'A') ? 'margin-top:0px;':'')">
            <li style="color: black;padding-left: 0;" :id="`az_program_${letter}`" v-if="filter_programs(letter).length > 0">
              <div class="az-az-letters" style="max-width: 1100px;margin-left: auto;margin-right: auto;text-align: left;">
              {{letter}}
              </div>
            </li>
            <!--<li style="color: black">0-9</li>-->
            <!--
            <li uk-toggle="target: #modal-full" class="light-green" v-for="program in filter_programs(letter)" v-bind:key="program.series_id" @click="fetch_program_details(program.next_access_id)">{{program.series_title}}</li>
            -->
            <li class="light-green a-z-ul-program-title" v-for="program in filter_programs(letter)" v-bind:key="program.series_id" @click="to_all_airdates(program)">
              <div class="az-az-letters" style="max-width: 1200px;margin-left: auto;margin-right: auto;text-align: left;">
              {{program.series_title}}
              </div>
            </li>
        </ul>



        <div v-if="loading" style="margin-top:130px;">
            Loading...
        </div>

    </div>
</template>

<script>

/**
 * Reference / Support material:
 *
 * https://www.pbssocal.org/schedule/
 *
 */

import axios from 'axios'
import $ from 'jquery'
import _ from 'lodash'
import ProgramDetails from "./ProgramDetails";
import uk from "uikit";
import TopNavigationBar from "@/components/TopNavigationBar";

export default {
    name: "ProgramsAZ",
    components: {TopNavigationBar, ProgramDetails},
    props:['_channel','_search_query', 'exact_match'],
    data(){
        return {
            channel: 1,
            base_url: 'https://www.pbs12.org/',
            //end_point: 'https://www.pbs12.org/schedule_rest.php?/',
            programs_list: [],
            current_program: null,
            text_search_input: null,
            text_search_done: false,
            loading: false,
            date_range: { min_date_formatted: '', max_date_formatted: ''},
            az: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','0-9']
        }
    },
    computed:{
        end_point(){
            if(window.location.href.match(/localhost/)) return 'https://www.pbs12.org/schedule_rest.php?/'
            return `https://${window.location.href.split('/')[2]}/schedule_rest.php?/`
        },
        filtered_programs_list(){
            if(this.programs_list.programs != undefined) {
                if (this.text_search_input != null && this.text_search_input.length > 2) {
                    // return _.filter(this.programs_list.programs, (prg) => prg.series_title.toLowerCase().match(this.text_search_input.toLowerCase()))
                    return _.filter(this.programs_list.programs, (prg) => prg.genre_list.toLowerCase().match(this.text_search_input.toLowerCase()))
                }
                return this.programs_list.programs
            }
            return null
        },
        filtered_programs_list_size(){
          let vm = this
          // console.log('filtered_programs_list: ', this.filtered_programs_list)
          // console.log('this._channel: ', this._channel)
          if(this.filtered_programs_list != null) {
            let ret = this.filtered_programs_list
            if(parseInt(this._channel) === -1 || parseInt(this.channel) === -1) return ret.length
            return _.filter(ret, prg => {
              // console.log(`ch${vm._channel}`, prg[`ch${vm._channel}`])
              return prg[`ch${vm._channel}`] === '1'
            }).length
          }
          return null
        },
        list_genres(){
          let genres = []
          if(this.programs_list != undefined && this.programs_list.programs != undefined) {
            this.programs_list.programs.forEach((p) => {
              if (p.genre_list.length > 0 && genres.indexOf(p.genre_list) < 0) genres.push(p.genre_list)
            })
          }
          return genres
        }
    },
    created() {
        this.$watch("$route",() => {
            // this.$route.query is watched now as expected
            // console.log('current type:', this.type)
            // console.log('current type:', this.$route.params)
            //console.log('USING CHANNEL _channel: ', this._channel)

            if(this._channel != undefined && parseInt(this._channel) > -2 && parseInt(this._channel) < 5) this.channel = this._channel
            //console.log('USING CHANNEL: ', this.channel)
            if(this._current_day != undefined && new Date(Date.parse(this._current_day)).getFullYear() > 2019){
                this.setup_date(new Date(Date.parse(this._current_day)))
            }else if(this._current_day != undefined){
                this.text_search_input = this._current_day
            }
            this.fetch_az_data()
        }, { immediate: true })
    },
    mounted() {
      console.log('USING CHANNEL _channel: ', this._channel)

      if(this._channel != undefined && parseInt(this._channel) > -2 && parseInt(this._channel) < 5) this.channel = this._channel
      if(this._search_query != undefined && this._search_query.length > 2) this.text_search_input = this.text_search_input
        //console.log('USING CHANNEL: ', this.channel)
      this.fetch_az_data()
    },
    methods:{
        text_search(){
        },
        translate_genre(genre){
          let _genre = genre.replace(/_/g,' ').replace(/-/g, ' ')
          return _genre.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()).
                          replace(/Arts Music/,'Arts & Music').
                          replace(/Science Nature/, 'Science & Nature').
                          replace(/Home How To/, 'Home & How-To').
                          replace(/News Public Affairs/, 'News & Public Affairs')

          // All
          // Arts & Music
          // Children
          // Culture
          // Drama
          // Food
          // Health
          // History
          // Home & How-To
          // Indie Films
          // News & Public Affairs
          // Science & Nature
          // Travel
        },
        format_date(fulldate){
            const event = new Date(Date.parse(fulldate))
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
            console.log(event.toLocaleDateString('en-US', options))
            return event.toLocaleDateString('en-US', options)
        },
        filter_programs(letter){
            let vm = this

            let ret = null
            if(letter === '0-9'){
                ret = _.filter(this.filtered_programs_list, prg => prg.series_title.substr(0,1).match(/[0-9#]/))
            }else{
                ret = _.filter(this.filtered_programs_list, prg => prg.series_title.substr(0,1).match(letter))
            }

            if(parseInt(this._channel) === -1) return ret
            return _.filter(ret, prg => {
                // console.log(`ch${vm._channel}`, prg[`ch${vm._channel}`])
                return parseInt(prg[`ch${vm._channel}`]) === 1
            })
        },
        reset_players_height(){
            let _class = '.uk-accordion-title'
            if($('.uk-accordion-title').width() == undefined) _class = '.uk-modal-dialog'
            //console.log('program details width: ', $(_class).width())

            if($(_class).width() * .57 > 0) {
                setTimeout(() => {
                    let height = $(_class).width() *.50
                    if($(_class).width() > 900) height = $(_class).width()*.17
                    //console.log('program details width: ', height)
                    $('.pbs_media_manager_iframe').height(height)
                    $('.pbs_media_manager_iframe').css('margin-bottom', '20px')
                }, 2000)
            }
        },
        change_channel(channel=undefined){
          // console.log(channel instanceof Event)
          if(!(channel instanceof Event))  this.channel = channel
          this.$router.push({ name: 'programs_az', params: { '_channel': this.channel, _search_query: this.text_search_input }})
        },
        reset_search(){
            this.$router.push({ name: 'schedule', params: { 'type': 1, '_channel': this.channel}})
        },
        toIsoDate(date){
            return `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`
        },
        fetch_az_data(){

            console.log(`loading fetch_az_data`)
            console.log(`url: ${this.endpoint_url()}`)

            this.loading = true

            axios.get(this.endpoint_url(), {
                data: {},
                headers: {'Content-Type': 'application/json'}
            }).then( response => {
                this.loading = false
                this.programs_list = response.data
                this.date_range = response.data.date_range
                //this.change_channel('1')
                // this.change_channel(this.channel)
                //this.channel = channel
            }).catch(reason => {
                console.log('failed to get schedule data', reason)
            })
        },
        to_all_airdates(air_data){
          let title = air_data.series_title
          let vm = this
          console.log('to all airdates: ', air_data)
          console.log('to all airdates: ', title)
          console.log('current params: ', vm.$route.params)
          // let channel = (vm.$route.params._channel != undefined) ? vm.$route.params._channel:'1'
          let type = (vm.$route.params.type != undefined) ? vm.$route.params.type:'1'

          this.$router.push({ name: 'schedule', params: { 'type': type, '_channel': -1, '_current_day': title, exact_match: '1', genre_list: air_data.genre_list }})
          try {
            uk.modal('#modal-full').hide()
          }catch (e) {
            //
          }
        },
        fetch_program_details(id){
            console.log(`loading fetch_program_details`)
            console.log(`url: ${this.endpoint_url()}/${id}`)

            this.loading = true
            this.current_program = null

            axios.get(`${this.endpoint_url()}/${id}`, {
                data: {},
                headers: {'Content-Type': 'application/json'}
            }).then( response => {
                this.loading = false
                console.log('current program: ', response.data)
                this.current_program = response.data
            }).catch(reason => {
                console.log('failed to fetch_program_details', reason)
            })
        },
        endpoint_url(){
            return `${this.end_point}programs_az`
        }
    }
}
</script>

<style scoped>

    .schedule-header{
        background: #f8eeca;
        /*border-bottom: 22px solid #333;*/
        padding-top: 10px;
        padding-bottom: 0px;
        right: 0;
        left: 0;

        position: -webkit-sticky; /* Safari */
        position: sticky;
        top: -1px;
        z-index: 999;
    }
    .schedule-channel-selector{
        background-color: white;
        border: 2px solid black;
        height: 44px;
        padding-top: 9px;
    }
    a{
        text-decoration: none;
    }
    .a-z-navbar{
        background: #f6df99;min-height: 37px;text-align: center;font-size: 15px;font-weight: bold;
        padding-top: 15px;
        padding-bottom: 10px;
        text-align: justify;/*letter-spacing: 0.9vw;*/
        text-align: center;
        margin-top: 15px;
    }
    .a-z-navbar >a{
        color: rgb(1, 174, 180);
    }
    .uk-list-divider>:nth-child(n+2) {
        margin-top: 0px;
        padding-top: 15px;
    }

    .uk-tab>.uk-active>a {
      color: rgb(1 174 180);
      border-color: unset;
      font-family: Avenir-heavy;
      border-top: unset
    }

    .select-pbs-schedule-dropdown-option{
      font-family: sans-serif;
    }
    a:hover{
        text-decoration: none;
    }
    a:active{
        text-decoration: none;
    }
    @media screen and (min-width: 1180px){
      .schedule-channel-selector-input{
        margin-left: 150px;
      }
    }

</style>